import { FC } from "react";

export const IndividualReport: FC = () => {
  return <div>123</div>;
};
